import { QueryClient } from "@tanstack/react-query";

export function createQueryClient() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        gcTime: 60 * 1000,
        structuralSharing: false,
        // getNextPageParam(lastPage: any, allPages) {
        //   if (lastPage.data.length === 0) return undefined;
        //   return allPages.length;
        // },
        refetchOnWindowFocus: false,
        retry: false,
        throwOnError: false,
      },

      mutations: {
        throwOnError: false,
      },
    },
  });

  return queryClient;
}
